export class ErrorHandlingError extends Error {
  constructor(originalError) {
    super();
    this.name = 'ErrorHandlingError';
    this.message = `An error occurred while handling the following error: ${originalError.message}`;
    this.originalError = originalError;
  }
}
